import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import './ServiceOffering.css';
import Unit from '../Modular/Unit';

const services = [
  'UI-UX',
  'Payments',
  'Email Comms',
  'Integrations',
  'Secure Auth',
  'Booking',
];

const ServiceOffering = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => {
        return (prev + 1) % services.length;
      });
    }, 7000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <Unit marginBottom="sm" height="0">
      <div>
        <AnimatePresence mode="wait">
          <motion.p
            key={count}
            className="service-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.8, ease: 'easeInOut' }}
          >
            {services[count]}
          </motion.p>
        </AnimatePresence>
      </div>
    </Unit>
  );
};

export default ServiceOffering;
